<template>
  <div>
    <ListItemFilters
      icon="ui-icon-place"
      :title="t(getPlaceLabel({ place: lpuFiltersState.place }), options)"
      :subtitle="lpuFiltersState.place ? t(defaultPlaceName, options) : undefined"
      @click="openDialog"
    />

    <PlaceModal
      :value="isDialogOpened"
      is-back
      @place:selected="onClickPlace"
      @input="handleClosePlaceModal"
    >
      <template #footer="{ selectedPlace }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedPlace"
            @click="handlePlaceSelected(selectedPlace)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </PlaceModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/lpu/functions/deepEqual'
import getPlaceLabel from 'www/vue_components/common/TheFilters/lpu/components/PlaceFilters/functions/getPlaceLabel'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import PlaceModal from 'www/vue_components/common/TheFilters/lpu/components/PlaceFilters/components/PlaceModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: lpuFiltersState } = toRefs(props)

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemLpuPlace')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const defaultPlaceName = commonStore.lpuList.hasMetro
  ? 'Метро, район'
  : 'Район'

const hasUnsavedPlace = computed(() => (
  !deepEqual(lpuFiltersState.value.place, filtersStore.unsavedFilters.place)
))

const handleClosePlaceModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(lpuFiltersState.value)
}

const onClickPlace = (place: Filters['place']) => {
  filtersStore.updateUnsavedFilters({ place })
}

const handlePlaceSelected = (place: Filters['place']) => {
  closeDialog()

  filtersStore.updateUnsavedFilters({ place })
  emit('input', filtersStore.unsavedFilters)
}
</script>
